
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import PropositionOptionForm from '@/components/forms/PropositionOptionForm.vue'

const configModule = namespace('config')

@Component({
  components: {
    BaseCardContainer,
    PropositionOptionForm
  }
})
export default class OptionCreate extends Vue {
  @configModule.Action('createPropositionOptionAction') createPropositionOption: any
  @configModule.Action('getPropositionOptionsAction') getPropositionOptions: any

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createPropositionOption(data).then(async (data: any) => {
      this.getPropositionOptions()
      this.$router.push({name: 'OptionList'})
    })
  }

  onCancel() {
    this.$router.replace({name: 'OptionList'})
  }
}
